import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import pathify, { make } from 'vuex-pathify';
import models from '@/models';
import state from './state';


// vuex
Vue.use(Vuex);

// models
const database = new VuexORM.Database();
for (const model of Object.values(models)) {
  database.register(model);
}

// save initial state for reset
const initial = JSON.parse(JSON.stringify(state));

// store
export default new Vuex.Store({
  state,
  mutations: {
    reset (state) {
      const clone = JSON.parse(JSON.stringify(initial));
      Object.keys(clone).forEach(key => {
        state[key] = clone[key];
      });
    },
    ...make.mutations(state)
  },
  plugins: [pathify.plugin, VuexORM.install(database)],
});
